import React, {useState, useEffect}  from 'react';
import app from "./firebase";
import firebase from "firebase/app";
import "firebase/database";
import { useTheme } from '@material-ui/core/styles';
import { LineChart, Line, XAxis, YAxis, Label, ResponsiveContainer } from 'recharts';
import Title from './Title';

// Generate Sales Data
function createData(time, amount) {
  return { time, amount };
}


const data = [
  createData('00:00', 99),
  createData('03:00', 98),
  createData('06:00', 96),
  createData('09:00', 95),
  createData('12:00', 97),
  createData('15:00', 90),
  createData('18:00', 85),
  createData('21:00', 80),
  createData('24:00', undefined),
];

console.log(data)

export default function Chart() {
  const theme = useTheme();
  const [chamberData, setChamberData] = useState(()=>{
    return 0
  })

  useEffect(() => {
    const chamberListen = firebase.database().ref('Chamber1');
    
    chamberListen.on("value", (snapshot) => {
       var chambers = [];
     
       var mq2Values=[],mq2Fetch, mq2Points = [], mq2Timestamp=[], plotPoints=[]
       var chamberKey = snapshot.key;
       var chamberData = snapshot.val();
       var result

       chambers.push({chamberKey, chamberData})
       console.log(chambers);
       
       mq2Fetch = Object.values(chamberData.room.mq2)
       console.log(mq2Fetch)
      
       
       //Mq2 Values Array
      mq2Fetch.forEach((object)=>{
        mq2Values.push(object.value)
      })
      console.log(mq2Values)

      // Mq2 Timestamp Array
      mq2Fetch.forEach((object)=> {
        mq2Timestamp.push(object.timestamp.toString().split(' ')[4])
        
      })
      console.log(mq2Timestamp)

       

       result =  mq2Values.reduce(function(result, field, index) {
         result[mq2Timestamp[index]] = field;
         return result;
       }, {})
       console.log(result)
       
       
       Array(result).forEach((object)=>{
         
         console.log(object.key)
       })
       
       mq2Fetch.forEach((object)=>{
        plotPoints.push(createData(object.timestamp.toString().split(' ')[4], object.value))
       })
       console.log(plotPoints)
       setChamberData(plotPoints)
 })
      



  },[])
  


  console.log(chamberData)
  //   const chamberListen = firebase.database().ref('Chamber1');
    
  //    chamberListen.on("value", (snapshot) => {
  //     var chambers = [];
  //     var numbers = Array.from(Array(739).keys())
  //     var mq2Values, mq2Points = []
  //       var chamberKey = snapshot.key;
  //       var chamberData = snapshot.val();
  //       var result

  //       chambers.push({chamberKey, chamberData});
  //       // chambers.sort();
  //       // document.getElementById("Chambers").innerHTML = chambers
  //       console.log(chambers);
        
  //       // mq2Values = Object.values(chamberData.room.mq2)
  //       // console.log(mq2Values)
        
  //       // mq2Values.forEach((value)=>{
  //       //   mq2Points.push(value)
  //       //   console.log(mq2Points)
  //       // })

  //       // result =  mq2Points.reduce(function(result, field, index) {
  //       //   result[numbers[index]] = field;
  //       //   return result;
  //       // }, {})
  //       // console.log(result)
  //       // setPoints({result})
        
  // })

  
  



  return (
    <React.Fragment>

      <Title>Today</Title>
      
      <ResponsiveContainer width="90%" height={169}>
        <LineChart
        
          data={chamberData}
          margin={{
            top: 16,
            right: 16,
            bottom: 0,
            left: 24,
          }}
        >
          <XAxis dataKey="time" stroke={theme.palette.text.secondary} />
          <YAxis stroke={theme.palette.text.secondary}>
            <Label
              angle={270}
              position="left"
              style={{ textAnchor: 'middle', fill: theme.palette.text.primary }}
            >
              Mq2
            </Label>
          </YAxis>
          <Line type="monotone" dataKey="amount" stroke={theme.palette.primary.main} dot={false} />
        </LineChart>
        </ResponsiveContainer>
    </React.Fragment>
  );
}